import { Button } from '@/components/ui/button'
import type { PhoneNumber } from 'honeygrid-types'
import { Phone, Plus } from 'lucide-react'

interface PhoneNumbersCardsProps {
	phoneNumbers: PhoneNumber[]
	onSelect: (phoneNumber: PhoneNumber) => void
	onAdd: () => void
	selectedId?: string
}

const getStatusBadge = (status: string) => {
	const baseClasses = "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
	switch (status) {
		case 'active':
			return `${baseClasses} bg-green-100 text-green-800`
		case 'pending':
			return `${baseClasses} bg-yellow-100 text-yellow-800`
		case 'released':
			return `${baseClasses} bg-gray-100 text-gray-800`
		default:
			return `${baseClasses} bg-gray-100 text-gray-800`
	}
}

export function PhoneNumbersCards({ phoneNumbers, onSelect, onAdd, selectedId }: PhoneNumbersCardsProps) {
	if (phoneNumbers.length === 0) {
		return (
			<div className="flex flex-col items-center justify-center text-center space-y-3 bg-[#3A2E2F]/5 h-40 py-8">
				<div className="h-8 w-8 shrink-0 flex items-center justify-center">
					<Phone className="h-8 w-8 text-foreground/60" />
				</div>
				<p className="text-sm font-medium text-muted-foreground">No phone numbers yet</p>
				<Button variant="outline" size="sm" onClick={onAdd}>
					<Plus className="h-4 w-4 mr-2" />
					Add Phone Number
				</Button>
			</div>
		)
	}

	return (
		<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
			{phoneNumbers.map((phoneNumber) => (
				<div
					key={phoneNumber.uuid}
					className={`border border-[#3A2E2F]/20 rounded-md p-4 cursor-pointer hover:shadow-md transition-shadow ${
						phoneNumber.uuid === selectedId ? 'ring-2 ring-primary' : ''
					}`}
					onClick={() => onSelect(phoneNumber)}
				>
					<div className="flex items-start gap-3">
						<Phone className="h-5 w-5 text-muted-foreground mt-0.5" />
						<div className="flex-1 min-w-0">
							<div className="font-medium truncate">{phoneNumber.phone_number}</div>
							<div className="text-sm text-muted-foreground truncate">Twilio</div>
							<div className="mt-2">
								<span className={getStatusBadge(phoneNumber.status)}>
									{phoneNumber.status}
								</span>
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	)
}